import { useEffect } from "react"
import smoothscroll from "smoothscroll-polyfill"

export const scrollToAnchor = () => {
  const anchor = document.getElementById(window.location.hash.substr(1))
  if (anchor) {
    const scrollBy = () => {
      window.scrollBy({
        top: anchor.getBoundingClientRect().top,
        left: 0,
        behavior: "smooth",
      })
    }

    scrollBy()
    setTimeout(scrollBy, 500)
  }
}

export const useSmoothScroll = () => {
  if (typeof window !== `undefined`) {
    smoothscroll.polyfill()
  }

  useEffect(() => {
    scrollToAnchor()
    document.documentElement.style.scrollBehavior = "smooth"

    return () => {
      document.documentElement.style.scrollBehavior = ""
    }
  }, [])
}
